const getWeeksBetweenDates = (date1, date2) => {
  const milliInWeek = 60 * 60 * 24 * 7 * 1000;
  const bigDate = date1 > date2 ? date1 : date2;
  const smallDate = date1 > date2 ? date2 : date1;

  const dif = (bigDate.getTime() - smallDate.getTime()) / milliInWeek;

  return Math.abs(Math.round(dif));
};

const formatDateWithNthNumber = (date, mFormat = 'long') => {
  const day = date.getDate();
  const month = date.toLocaleString('default', { month: mFormat });
  const year = date.getFullYear();

  const nthNumber = (number) => {
    if (number > 3 && number < 21) return 'th';
    switch (number % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };

  const formattedDate = `${day}${nthNumber(day)} ${month} ${year}`;
  return formattedDate;
};

const dateFunctions = {
  getWeeksBetweenDates: getWeeksBetweenDates,
  formatDateWithNthNumber: formatDateWithNthNumber,
};

export default dateFunctions;
